import { CyberpassButton } from "../Input";
import LogoutIcon from "../../public/logout.svg?react";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectUser } from "../store/auth";
import { clearCurrent, clearRecent } from "../store/customer";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "../i18n";

/**
 * @returns {React.Component}
 */
export default function LogOut() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(selectUser);

  useEffect(() => {
    if (user != null) return;
    navigate("/login");
  }, [user]);

  return (
    <CyberpassButton
      style="secondary"
      onClick={() => {
        dispatch(clearCurrent());
        dispatch(clearRecent());
        dispatch(logout());
      }}
      Icon={LogoutIcon}
    >
      {t("admin.logout")}
    </CyberpassButton>
  );
}
